import Box from '@mui/material/Box';
import { FormCheckBox, useTrackedFormik } from '@omnigenbiodata/ui';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { StepProps } from '../../../../core/types/common.types';
import EnrolmentStepContainer from '../EnrolmentStepContainer';

function Consent1Step({ currentStep, onStepForward, onStepBack, values }: StepProps) {
  const { t } = useTranslation('portal');

  const validationSchema = yup.object().shape({
    consent1: yup
      .boolean()
      .required(t('forms.consent1.msg.required') as string)
      .oneOf([true], t('forms.consent1.msg.required') as string),
  });

  const formik = useTrackedFormik(
    {
      initialValues: { consent1: false, ...values },
      validationSchema,
      onSubmit: (formValue: any) => {
        onStepForward(formValue);
      },
    },
    'consent1',
  );

  return (
    <EnrolmentStepContainer
      onSubmit={formik.handleSubmit}
      title={t('enrol.consent1.title')}
      text={t('enrol.consent1.text') as string}
      onBack={onStepBack}
      showBack={currentStep > 0}
    >
      <Box mb={4} px={{ xs: 3, sm: 0 }}>
        <FormCheckBox
          error={formik.errors.consent1}
          name="consent1"
          label={t('forms.consent1.label')}
          onChange={formik.handleChange}
          touched={formik.touched.consent1}
          value={formik.values.consent1}
        />
      </Box>
    </EnrolmentStepContainer>
  );
}

export default Consent1Step;
